import { render } from "./Percentage.vue?vue&type=template&id=7440e9be"
import script from "./Percentage.vue?vue&type=script&lang=js"
export * from "./Percentage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__